module.exports = __webpack_public_path__ + "static/img/pic_download.ecdfd50d.png";